import React, { useContext, useEffect, useState } from 'react'
import { message, Select } from 'antd'
import ListComponent from '@/components/listComponent'
import TopSearch from '@/components/TopSearch'
import YhTooltip from '@/components/YhTooltip'
import { MyContext } from '@/store/myContext'
import { MaintainOrdeReturnStatus, MaintainOrdeStatus } from '@/utils/enum'
import { exportMaintainOrderMaterialList, getMaintainOrderMaterialPage } from '@/service/ordersService'
import RepairPickingListDetail from '../repairPickingList/detail'
import MaterialUsedRecord from '../repairPickingList/log'

const { Option } = Select
const PAGE_SIZE = 10
const DEFAULT_ORDERS = [{ column: 'createTime', rule: 'DESC' }]

export default () => {
    const { state } = useContext(MyContext)
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchValue, setSearchValue] = useState({})
    const [orders, setOrders] = useState(DEFAULT_ORDERS)
    const [sorterInfo, setSorterInfo] = useState({})
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [pagination, setPagination] = useState({ total: 0, current: 1, pageSize: PAGE_SIZE })
    const [detailData, setDetailData] = useState({ visible: false, maintainOrderId: '' })
    const [logData, setLogData] = useState({ visible: false, id: '' })

    useEffect(() => {
        if (state.activeMenu === 'repairPickingListDetail') {
            loadData(1, searchValue)
        }
    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    const buildParams = (current, search, tableOrders = orders) => ({
        searchItem: { ...search },
        startTime: search.startTime || null,
        endTime: search.endTime || null,
        pageNum: current,
        pageSize: PAGE_SIZE,
        orders: tableOrders,
    })

    const loadData = (current = 1, search = searchValue, refresh = false, tableOrders = orders) => {
        setLoading(true)
        getMaintainOrderMaterialPage(buildParams(current, search, tableOrders))
            .then((res) => {
                const result = res.retData
                setList(result.list || [])
                setPagination({ total: result.total || 0, current, pageSize: PAGE_SIZE })
                if (refresh) {
                    message.success('刷新成功')
                }
            })
            .finally(() => setLoading(false))
    }

    const exportData = () => {
        const params = buildParams(1, searchValue)
        if (selectedRowKeys.length > 0) {
            params.searchItem.ids = selectedRowKeys
        }
        exportMaintainOrderMaterialList(params).then((res) => {
            if (res.retCode === 200) {
                message.success(`导出任务已创建：${res.retData}`)
            } else {
                message.error(res.retMsg)
            }
        })
    }

    const onTableChange = (page, _filters, sorter) => {
        let nextOrders = DEFAULT_ORDERS
        if (sorter && sorter.field && sorter.order) {
            nextOrders = [{ column: sorter.field, rule: sorter.order === 'ascend' ? 'ASC' : 'DESC' }]
            setSorterInfo(sorter)
        } else {
            setSorterInfo({})
        }
        setOrders(nextOrders)
        loadData(page.current, searchValue, false, nextOrders)
    }

    const sortableColumn = (field) => ({
        sorter: true,
        sortOrder: sorterInfo.field === field ? sorterInfo.order : null,
    })

    const columns = [
        {
            title: '领料单号',
            dataIndex: 'maintainOrderCode',
            fixed: 'left',
            width: 150,
            ...sortableColumn('maintainOrderCode'),
            render: (text, record) => (
                <span
                    style={{ color: '#2e3aeb', cursor: 'pointer' }}
                    onClick={() => setDetailData({ visible: true, maintainOrderId: record.maintainOrderId })}
                >
                    {text}
                </span>
            ),
        },
        { title: '领料人', dataIndex: 'userName', width: 100, render: (text) => <YhTooltip text={text} maxWidth={160} /> },
        { title: '联系电话', dataIndex: 'userPhone', width: 120 },
        { title: '商品编号', dataIndex: 'materialCode', width: 130, ...sortableColumn('materialCode') },
        { title: '商品名称', dataIndex: 'materialName', width: 160, ...sortableColumn('materialName'), render: (text) => <YhTooltip text={text} maxWidth={220} /> },
        { title: '品牌', dataIndex: 'brandName', width: 100 },
        { title: '单位', dataIndex: 'unitName', width: 70 },
        { title: '采购单号', dataIndex: 'purchaseCode', width: 150 },
        { title: '仓库', dataIndex: 'warehouseName', width: 120, ...sortableColumn('warehouseName') },
        { title: '货位', dataIndex: 'shelfCode', width: 100 },
        { title: '平台配件', dataIndex: 'isPlatform', width: 90, render: (value) => (value === 1 ? '是' : '否') },
        { title: '领料状态', dataIndex: 'status', width: 90, ...sortableColumn('status'), render: (value) => MaintainOrdeStatus[value] || value || '-' },
        {
            title: '最新退料状态',
            dataIndex: 'returnStatus',
            width: 110,
            render: (value) => MaintainOrdeReturnStatus[value] || value || '-',
        },
        { title: '领料数量', dataIndex: 'pickupNum', width: 90, ...sortableColumn('pickupNum') },
        {
            title: '已用数量',
            dataIndex: 'usedNum',
            width: 90,
            ...sortableColumn('usedNum'),
            render: (value, record) => (
                <span style={{ color: '#2e3aeb', cursor: 'pointer' }} onClick={() => setLogData({ visible: true, id: record.id })}>
                    {value || 0}
                </span>
            ),
        },
        { title: '剩余数量', dataIndex: 'remainingNum', width: 90, ...sortableColumn('remainingNum') },
        { title: '退料数量', dataIndex: 'returnNum', width: 90, ...sortableColumn('returnNum'), render: (value) => value || 0 },
        { title: '采购单价', dataIndex: 'price', width: 90 },
        { title: '最近销售价', dataIndex: 'lateSalePrice', width: 100 },
        { title: '备注', dataIndex: 'remark', width: 140, render: (text) => <YhTooltip text={text} maxWidth={220} /> },
        { title: '创建人', dataIndex: 'createUserName', width: 100 },
        { title: '明细创建时间', dataIndex: 'createTime', width: 170, ...sortableColumn('createTime') },
        { title: '更新时间', dataIndex: 'updateTime', width: 170, ...sortableColumn('updateTime') },
    ]

    const searchList = {
        normalList: [
            { type: 'input', placeholder: '请输入领料单号', valueName: 'maintainOrderCode' },
            { type: 'input', placeholder: '请输入商品编码', valueName: 'materialCode' },
            { type: 'input', placeholder: '请输入商品名称', valueName: 'materialName' },
            { type: 'input', placeholder: '请输入领料人姓名', valueName: 'userName' },
            {
                type: 'select',
                placeholder: '请选择领料状态',
                valueName: 'status',
                optionList: () => Object.entries(MaintainOrdeStatus).map(([value, label]) => <Option key={value} value={value}>{label}</Option>),
            },
            { type: 'RangePicker', placeholder: ['明细创建开始时间', '明细创建结束时间'], valueName: ['startTime', 'endTime'], span: 16, xxl: 8 },
        ],
        hideList: [
            { type: 'input', placeholder: '请输入联系电话', valueName: 'userPhone' },
            { type: 'input', placeholder: '请输入仓库名称', valueName: 'warehouseName' },
            { type: 'input', placeholder: '请输入货位编码', valueName: 'shelfCode' },
            { type: 'input', placeholder: '请输入采购单号', valueName: 'purchaseCode' },
            {
                type: 'select',
                placeholder: '请选择剩余状态',
                valueName: 'remainingState',
                optionList: () => (
                    <>
                        <Option value="have-leftovers">有剩余</Option>
                        <Option value="no-remaining">已用完</Option>
                    </>
                ),
            },
            {
                type: 'select',
                placeholder: '请选择最新退料状态',
                valueName: 'returnStatus',
                optionList: () => Object.entries(MaintainOrdeReturnStatus).map(([value, label]) => <Option key={value} value={value}>{label}</Option>),
            },
            {
                type: 'select',
                placeholder: '请选择配件来源',
                valueName: 'isPlatform',
                optionList: () => (
                    <>
                        <Option value={1}>平台配件</Option>
                        <Option value={0}>非平台配件</Option>
                    </>
                ),
            },
        ],
    }

    const buttons = [
        { content: '刷新', click: () => loadData(pagination.current, searchValue, true) },
        { content: '导出', click: exportData },
    ]

    return (
        <>
            {state.activeMenu === 'repairPickingListDetail' && (
                <>
                    <TopSearch
                        title="维修领料单明细"
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title="维修领料单明细"
                        buttons={buttons}
                        columns={columns}
                        dataSource={list}
                        loading={loading}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        scroll={{ x: 2900 }}
                        rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
                    />
                    {detailData.visible && (
                        <RepairPickingListDetail
                            rowInfo={{ id: detailData.maintainOrderId }}
                            visible={detailData.visible}
                            setVisible={(visible) => setDetailData({ ...detailData, visible })}
                            mode="look"
                        />
                    )}
                    {logData.visible && <MaterialUsedRecord logData={logData} setLogData={setLogData} />}
                </>
            )}
        </>
    )
}
